import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'pgsPaginator'
})
export class PgsPaginatorPipe implements PipeTransform {
  transform(value: any[], paginator): any[] {
    const { totalToShow, currentPage } = paginator;
    return [...value.slice(totalToShow * (currentPage - 1), totalToShow * (currentPage))];
  }
}
